export default "/HammersmithOne-Regular.6c684c4e-404d4f.ttf";